export enum Layout {
  ESIGN = 'esign',
  DMS = 'dms',
}
